import DayPicker from './DayPicker';
import './ComplianceBar.css';

function ComplianceBar({
    checkedCount,
    totalCount,
    weeklyCheckedCount = 0,
    weeklyTotalCount = 0,
    streak,
    complianceRate,
    history,
    selectedDate,
    onSelectDate,
    isSelectedComplete,
    onCheckAll,
}) {
    if (totalCount === 0 && weeklyTotalCount === 0) return null;

    const pct = totalCount > 0 ? Math.round((checkedCount / totalCount) * 100) : 0;
    const weeklyPct = weeklyTotalCount > 0 ? Math.round((weeklyCheckedCount / weeklyTotalCount) * 100) : 0;

    return (
        <div className="cb-root">
            <div className="cb-stats">
                {totalCount > 0 && (
                    <div className="cb-progress-group">
                        <span className="cb-progress-section-label">Daily</span>
                        <div className="cb-progress">
                            <div
                                className={`cb-progress-bar ${pct === 100 ? 'cb-progress-bar--done' : ''}`}
                                style={{ width: `${pct}%` }}
                            />
                        </div>
                        <span className="cb-progress-label">
                            {checkedCount}/{totalCount}
                        </span>
                    </div>
                )}
                {weeklyTotalCount > 0 && (
                    <div className="cb-progress-group">
                        <span className="cb-progress-section-label">Weekly</span>
                        <div className="cb-progress cb-progress--weekly">
                            <div
                                className={`cb-progress-bar ${weeklyPct === 100 ? 'cb-progress-bar--done' : ''} cb-progress-bar--weekly`}
                                style={{ width: `${weeklyPct}%` }}
                            />
                        </div>
                        <span className="cb-progress-label">
                            {weeklyCheckedCount}/{weeklyTotalCount}
                        </span>
                    </div>
                )}
                <div className="cb-badges">
                    {streak > 0 && (
                        <span className="cb-badge cb-badge--streak">{streak}d streak</span>
                    )}
                    {complianceRate > 0 && (
                        <span className="cb-badge cb-badge--rate">{complianceRate}%</span>
                    )}
                </div>
            </div>
            <div className="cb-day-row">
                <DayPicker
                    history={history}
                    selectedDate={selectedDate}
                    onSelectDate={onSelectDate}
                />
                {onCheckAll && (
                    isSelectedComplete ? (
                        <span className="cb-all-done">All done</span>
                    ) : (
                        <button type="button" className="cb-check-all" onClick={onCheckAll}>
                            Check All
                        </button>
                    )
                )}
            </div>
        </div>
    );
}

export default ComplianceBar;
